import { useState } from 'react';

export default function ContactForm() {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "3c4bb065-a660-4b0e-9361-183b0dbfe01e");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    setResult(data.success ? "Üzenet elküldve! Köszönöm megkeresését!" : "Hiba! Üzenet küldése sikertelen! Próbálja meg később.");
  };
  


return (
    <div className='contact-container-all'>
    <div className='contact-container'>
      <h1>Felkeltettem érdeklődését?</h1>
      <h2>Vegye fel velem a kapcsolatot!</h2>

      <form onSubmit={onSubmit}>
        <h2>Név:</h2>
        <input type="text" name="name" required/>
        <h2>Email:</h2>
        <input type="email" name="email" required/>
        <h2>Üzenet:</h2>
        <textarea name="message" required></textarea>
        <button  type="submit">Küldés</button>
        
      </form>
  </div>
        <p className='contact-result'>{result}</p>

  </div>
  );
}
